class VwStkdepotalepbaslikDTO {
    id: number = null;
    depotanimId?: number = null;
    kullaniciId?: number = null;
    tarihsaat?: string = null;
    islemdurum?: number = null;
    aciklama?: string = "";
    talepDepotanimId?: number = null;
    talepKullaniciId?: number = null;
    talepTarihsaat?: string = null;
    talepAciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    fkIptalneden?: number = null;
    depoAdi?: string = "";
    depoId?: number = null;
    talepedenDepoAdi?: string = "";
    islemdurumad?: string = "";
    talepedenkullanici?: string = "";
    taleponayseviye?: number = null;
    transferkullaniciId?: number = null;
    transfertarihsaat?: string = null;
    transferaciklama?: string = "";
    fkRedneden?: number = null;
    rednedenaciklama?: string = "";
    sononayyapildi?: string = "H";
}
export default VwStkdepotalepbaslikDTO;